import { SetObjectDataPropertyHelperBase } from './SetObjectDataPropertyHelperBase';
export class SetDataSymbolObjectPropertyHelper extends SetObjectDataPropertyHelperBase {
    getObject(sb) {
        return sb.helpers.getSymbolObject;
    }
}

//# sourceMappingURL=SetDataSymbolObjectPropertyHelper.js.map
